import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Props = {
  margin?: 'small' | 'medium' | 'large'
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DividerHorizontal',
  props: {
    margin: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'margin-small': _ctx.margin === 'small',
      'margin-medium': _ctx.margin === 'medium',
      'margin-large': _ctx.margin === 'large'
    })
  }, null, 2))
}
}

})